module.exports = __webpack_public_path__ + "img/favicon-7e9897c.png";